// extracted by mini-css-extract-plugin
module.exports = {"contenedorFooter":"footer-module--contenedor-footer--3mUfH","imgFooter":"footer-module--img-footer--3ueWJ","hover":"footer-module--hover--3mmMl"};